import { get } from 'lodash';
import React, { useContext } from 'react';
import { AppContext } from '../../AppContext';
import useQueryWithCallbacks from '../../common/CommonUseQuery';
import useRouter from '../../common/useRouter';
import LoaderComponent from '../../components/LoaderComponent';
import { REFRESH_TOKEN } from './graphql/Queries';

const RefreshToken = () => {
  const { initializeAuth, getRefreshToken, dispatch } = useContext(AppContext);
  const { navigate, location } = useRouter()
  const pathname = location?.state?.pathname;
  const refreshToken = getRefreshToken();
  function successCallback(accessToken, authRefreshToken) {
    initializeAuth(accessToken, authRefreshToken);
  }

  const { loading } = useQueryWithCallbacks(REFRESH_TOKEN, {
    fetchPolicy: 'network-only',
    variables: {
      data: { refreshToken },
    },
    onCompleted(response) {
      const accessToken = get(response, 'refreshToken.token');
      const authRefreshToken = get(response, 'refreshToken.refreshToken');
      successCallback(accessToken, authRefreshToken);
      if (pathname) {
        navigate(pathname);
      } else {
        navigate(-1);
      }
    },
    onError() {
      dispatch({ type: 'LOGOUT' });
    },
  });

  if (loading) return <LoaderComponent />;

  return null;
};

export default RefreshToken;
